import {observer} from "mobx-react-lite";
import {FONT_COLOR, FONT_VARIANT} from "../../../../../components/fonts/font-props";
import './onboarding-plan-pricing.scss';
import { PlanStore } from "../../../../subscription-plans/stores/subscription-plans-store";
import FontBody2 from "../../../../../components/fonts/font-body2/font-body2";
import FontHeading2 from "../../../../../components/fonts/font-heading2/font-heading2";

interface IPlanPricing {
    plan: PlanStore;
    isCoveragePlan?: boolean;
}

const OnboardingPlanPricing: React.FC<IPlanPricing> = observer(({plan, isCoveragePlan}: IPlanPricing) => {
    return (
        <div className="onboarding-plan-pricing-wrapper">
            <div className="onboarding-plan-pricing-values">
                <FontHeading2 variant={FONT_VARIANT.BOLD}>
                    {plan.price === 0 ? 'Free' :plan.formattedPrice}
                </FontHeading2>
                <FontBody2 color={FONT_COLOR.PRIMARY2}>{isCoveragePlan ? ' / Unlimited returns' : ` / Month, ${plan.formattedRmaQuota} returns`}</FontBody2>
            </div>
        </div>
    );
});

export default OnboardingPlanPricing;